import { render, staticRenderFns } from "./stackColumn.vue?vue&type=template&id=93bb997e&scoped=true"
import script from "./stackColumn.vue?vue&type=script&lang=js"
export * from "./stackColumn.vue?vue&type=script&lang=js"
import style0 from "./stackColumn.vue?vue&type=style&index=0&id=93bb997e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bb997e",
  null
  
)

export default component.exports